import { BracketSeries } from "@portal-frontend-ssr/blast-api";

type MatchStatus = "won" | "lost" | "draw" | "scheduled";

interface TeamMatch extends BracketSeries {
  status: MatchStatus;
  points: number;
}

interface FindWonLostDrawMatchesOptions {
  teamId: string;
  matches: BracketSeries[];
}

export interface FindWonLostDrawMatchesOutput {
  points: number;
  wonMatches: TeamMatch[];
  lostMatches: TeamMatch[];
  drawMatches: TeamMatch[];
  scheduledMatches: TeamMatch[];
}

export const findWonLostDrawMatches = ({
  teamId,
  matches,
}: FindWonLostDrawMatchesOptions): FindWonLostDrawMatchesOutput => {
  const wonMatches: TeamMatch[] = [];
  const lostMatches: TeamMatch[] = [];
  const drawMatches: TeamMatch[] = [];
  const scheduledMatches: TeamMatch[] = [];
  let points = 0;

  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];

    if (match.teamA?.uuid === teamId) {
      if (match.teamAScore === 0 && match.teamBScore === 0) {
        scheduledMatches.push({ ...match, status: "scheduled", points: 0 });
        continue;
      }
      if (match.teamAScore > match.teamBScore) {
        wonMatches.push({ ...match, status: "won", points: match.teamAScore });
        points += match.teamAScore;
        continue;
      }
      if (match.teamAScore < match.teamBScore) {
        lostMatches.push({ ...match, status: "lost", points: 0 });
        continue;
      }
      if (match.teamAScore === match.teamBScore) {
        drawMatches.push({ ...match, status: "draw", points: match.teamAScore });
        points += match.teamAScore;
        continue;
      }
    }

    if (match.teamB?.uuid === teamId) {
      if (match.teamBScore === 0 && match.teamAScore === 0) {
        scheduledMatches.push({ ...match, status: "scheduled", points: 0 });
        continue;
      }
      if (match.teamBScore > match.teamAScore) {
        wonMatches.push({ ...match, status: "won", points: match.teamBScore });
        points += match.teamBScore;
        continue;
      }
      if (match.teamBScore < match.teamAScore) {
        lostMatches.push({ ...match, status: "lost", points: 0 });
        continue;
      }
      if (match.teamBScore === match.teamAScore) {
        drawMatches.push({ ...match, status: "draw", points: match.teamBScore });
        points += match.teamBScore;
        continue;
      }
    }
  }

  return {
    points,
    wonMatches,
    lostMatches,
    drawMatches,
    scheduledMatches,
  };
};
